import { DataType } from "./dataType"
import { FieldInstance } from "./fieldInstance"

export enum CalculationType {
	Numerical,
	Total,
	Average,
	AddToDate,
	DaysBetweenDates,
	DaysUntilOrFromToday,
	GreaterThan,
	LessThan,
	TimeSpentAs
}

const CalculationDataType: { [key in CalculationType]: string } = {
	[CalculationType.Numerical]: "number",
	[CalculationType.Total]: "number",
	[CalculationType.Average]: "number",
	[CalculationType.AddToDate]: "date",
	[CalculationType.DaysBetweenDates]: "number",
	[CalculationType.DaysUntilOrFromToday]: "number",
	[CalculationType.GreaterThan]: "checkbox",
	[CalculationType.LessThan]: "checkbox",
	[CalculationType.TimeSpentAs]: "time-spent"
}
export default CalculationDataType

export const CalculationDataTypeValue: { [calculationType in CalculationType]: DataType } = {
	[CalculationType.Numerical]: DataType.number,
	[CalculationType.Total]: DataType.number,
	[CalculationType.Average]: DataType.number,
	[CalculationType.AddToDate]: DataType.dateTime,
	[CalculationType.DaysBetweenDates]: DataType.number,
	[CalculationType.DaysUntilOrFromToday]: DataType.number,
	[CalculationType.GreaterThan]: DataType.boolean,
	[CalculationType.LessThan]: DataType.boolean,
	[CalculationType.TimeSpentAs]: DataType.timeSpentAsValue
}

export interface Permission {
	view: { id: string, title: string }[]
	edit: { id: string, title: string }[]
}

export interface Permissions {
	record: Permission
	case: Permission
}

export interface Field {
	id?: string;
	title: string;
	description: string | null;
	dataType: string | null;
	dataTypeTitle?: string;

	dataSourceId: string | null;
	dataSourceTitle: string | null;

	definitionId: string | null;
	definitionTitle: string | null;

	allowFiles: boolean;
	displayReadOnly?: boolean

	permissions: Permissions

	added?: boolean;
	add?: boolean;
	folder?: string|null;

	extensions?: { [key: string]: any };
}

export interface FieldSelected {
	field: string;
	primitiveDataType: number;
	dataTypeName: string;
}

export const FieldExtensionsIds = {
	Add: "add",
	CalculationType: "calculationType",
	DateField: "dateField",
	Expression: "expression",
	Fields: "fields",
	ShowTime: "showTime",
	Static: "static"
}

/**
 * Applicable Field Extension Ids for the Calculation Type.
 */
const calculatedValueExtensions: { [index: number]: string[] } = {}

calculatedValueExtensions[CalculationType.Numerical] =
[
	FieldExtensionsIds.CalculationType,
	FieldExtensionsIds.Fields,
	FieldExtensionsIds.Expression
]

calculatedValueExtensions[CalculationType.AddToDate] =
[
	FieldExtensionsIds.CalculationType,
	FieldExtensionsIds.Fields,
	FieldExtensionsIds.DateField,
	FieldExtensionsIds.Static,
	FieldExtensionsIds.Add,
	FieldExtensionsIds.ShowTime
]

interface CalculatedValueBase {
	calculationType: CalculationType
	fields: string[]
}

export interface CalculatedValueNumerical extends CalculatedValueBase {
	expression: string
}

export interface CalculatedValueAddToDate extends CalculatedValueBase {
	dateField: string | null
	static: string | null
	add: string[]
	showTime: boolean // will be true
}

export function formatFieldsForDefinitionTitle (fields: Field[]): FieldInstance[] {
	return fields.map(f => { return { field: f } as FieldInstance })
}

export function getExpressionFieldIds (expression: string): string[] {
	const fieldIds = expression.match(/(\{.+?\})/g)?.map(m => m.replace("{", "").replace("}", "")) ?? []
	return Array.from(new Set(fieldIds)) // Remove duplicates.
}
